export default {
  'ndtv.com': 'ndtv.com_1',
} as { [key: string]: string };
